module.exports = __webpack_public_path__ + "img/classic_blue_print.281ae8d6.png";